<article class="shiksha-kpi-card" [attr.data-type]="iconType()">
    <div class="shiksha-kpi-card__head">
        <div class="shiksha-kpi-card__label-wrap">
            <span class="shiksha-kpi-card__icon" [attr.data-type]="iconType()" aria-hidden="true">
                @switch (iconType()) {
                    @case ('revenue') {
                        <svg viewBox="0 0 24 24" focusable="false">
                            <path
                                d="M6 5a1 1 0 0 1 0-2h11a1 1 0 1 1 0 2h-4.12c1.53 1.16 2.4 2.93 2.54 5H17a1 1 0 1 1 0 2h-1.58c-.31 3.4-2.7 5.69-6.7 6.7l4.9 3.29a1 1 0 1 1-1.12 1.66l-7-4.7A1 1 0 0 1 5 18v-1a1 1 0 0 1 1-1c4.03 0 6.56-1.36 7.18-4H6a1 1 0 1 1 0-2h7.18A4.17 4.17 0 0 0 9.95 5H6Z"
                            />
                        </svg>
                    }
                    @case ('pipeline') {
                        <svg viewBox="0 0 24 24" focusable="false">
                            <path
                                d="M4 4h12a2 2 0 0 1 2 2v2h2v8h-2v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Zm0 2v12h12V6H4Zm14 4v4h2v-4h-2Z"
                            />
                        </svg>
                    }
                    @case ('gap') {
                        <svg viewBox="0 0 24 24" focusable="false">
                            <path
                                d="M4 5a1 1 0 0 1 1 1v10h10a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Zm16.71 3.29a1 1 0 0 1 0 1.42l-4.2 4.2a1 1 0 0 1-1.42 0L13 11.83l-2.29 2.3a1 1 0 0 1-1.42-1.42l3-3a1 1 0 0 1 1.42 0L15.8 11.8l3.49-3.5a1 1 0 0 1 1.42 0Z"
                            />
                        </svg>
                    }
                    @default {
                        <svg viewBox="0 0 24 24" focusable="false">
                            <path
                                d="M4 14a8 8 0 1 1 16 0 1 1 0 1 1-2 0 6 6 0 1 0-12 0 1 1 0 1 1-2 0Zm7.9-2.5a1 1 0 0 1 1.2.78l.03.14.17 2.25a1 1 0 0 1-2 .16l-.17-2.25a1 1 0 0 1 .77-1.08ZM12 17.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z"
                            />
                        </svg>
                    }
                }
            </span>
            <p class="shiksha-kpi-card__label">{{ label() }}</p>
        </div>
        <span class="shiksha-kpi-card__tooltip" tabindex="0" aria-label="Metric information">
            <span class="shiksha-kpi-card__tooltip-trigger" aria-hidden="true">i</span>
            <span class="shiksha-kpi-card__tooltip-content">{{ tooltipText() || label() }}</span>
        </span>
    </div>

    <div class="shiksha-kpi-card__metric-row">
        <p class="shiksha-kpi-card__value">{{ animatedValue() }}</p>
        <p class="shiksha-kpi-card__sub" [class.shiksha-kpi-card__sub--empty]="!subLabel()">
            {{ subLabel() || ' ' }}
        </p>
    </div>
</article>
